var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Property, ChildProperty, Complex } from '@syncfusion/ej2-base';
/**
 * Configures timeline settings of Gantt.
 */
export class TimelineTierSettings extends ChildProperty {
}
__decorate([
    Property('')
], TimelineTierSettings.prototype, "format", void 0);
__decorate([
    Property('None')
], TimelineTierSettings.prototype, "unit", void 0);
__decorate([
    Property(1)
], TimelineTierSettings.prototype, "count", void 0);
__decorate([
    Property(null)
], TimelineTierSettings.prototype, "formatter", void 0);
/**
 * Configures the timeline settings property in the Gantt.
 */
export class TimelineSettings extends ChildProperty {
}
__decorate([
    Property('Week')
], TimelineSettings.prototype, "timelineViewMode", void 0);
__decorate([
    Complex({}, TimelineTierSettings)
], TimelineSettings.prototype, "topTier", void 0);
__decorate([
    Complex({}, TimelineTierSettings)
], TimelineSettings.prototype, "bottomTier", void 0);
__decorate([
    Property(33)
], TimelineSettings.prototype, "timelineUnitSize", void 0);
__decorate([
    Property(0)
], TimelineSettings.prototype, "weekStartDay", void 0);
__decorate([
    Property(null)
], TimelineSettings.prototype, "weekendBackground", void 0);
__decorate([
    Property(true)
], TimelineSettings.prototype, "showTooltip", void 0);
__decorate([
    Property(true)
], TimelineSettings.prototype, "updateTimescaleView", void 0);
__decorate([
    Property(true)
], TimelineSettings.prototype, "showWeekend", void 0);
__decorate([
    Property('auto')
], TimelineSettings.prototype, "viewStartDate", void 0);
__decorate([
    Property('auto')
], TimelineSettings.prototype, "viewEndDate", void 0);
